<template>
  <div id="bottom">
    <Link to="https://www.baidu.com" target="_blank">
        <Text type="secondary">Copyright © 2023 蓝帆电子有限公司 All Rights Reserved</Text>
    </Link>

  </div>
</template>

<style scoped>
 @import url("index.less");
</style>